<template>
  <v-container>
    <div class="pa-3 display-1">
      権限切り替え
    </div>
    <v-row dense>
      <v-col cols="12" xl="12" dense>
        <v-card v-if= "!isSystemAdmin" flat outlined class="ma-5 pa-3">
          <div class="subtitle-2 mb-2">
            <v-icon class="mr-1" color="primary" small>mdi-information-outline</v-icon>
            <span class="primary--text">権限切り替え機能について</span>
          </div>
          <p class="caption">
              この機能はシステム管理者のみ利用できる機能です。<br>
          </p>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="isSystemAdmin" dense>
      <v-col cols="12" dense>
        <v-radio-group v-model="StaffPermit" class="ml-md-8 ml-2 mt-0" @change="changeStaffPermit" >
          <v-radio value="true">
            <template v-slot:label>
              <div>ジャパン・アナリストスタッフ権限にする</div>
            </template>
          </v-radio>
          <v-radio value="false">
            <template v-slot:label>
              <div>一般企業権限にする</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
      <v-col cols="12" dense>
        <v-radio-group v-model="AdminPermit" class="ml-md-8 ml-2 mt-0" @change="changeAdminPermit" >
          <v-radio value="true">
            <template v-slot:label>
              <div>事業所管理者権限にする</div>
            </template>
          </v-radio>
          <v-radio value="false">
            <template v-slot:label>
              <div>一般担当者権限にする</div>
            </template>
          </v-radio>
        </v-radio-group>
      </v-col>
    </v-row>
    
    </v-container>
</template>

<script>

export default {

name: "ChangePermit",
  head: {
    title: { inner: '権限の切り替え'},
  },
  computed: {
    isSystemAdmin : function() {
      return this.$store.state.isSystemAdmin
    },
  },
  mounted: async function() {
    if(this.$store.state.isStaff)
      this.StaffPermit = "true"
    else
      this.StaffPermit = "false"

    if(this.$store.state.isAdmin)
      this.AdminPermit = "true"
    else
      this.AdminPermit = "false"
  },
  data() {
    return {
      StaffPermit: false,
      AdminPermit: false
    };
  },
  methods: {
    changeStaffPermit: async function() {
      console.log("this.StaffPermit", this.StaffPermit)
      if(this.StaffPermit == "true"){
        this.$store.commit('setStaff', true )
        console.log("setStaff", true)
      }else {
        this.$store.commit('setStaff', false )
        console.log("setStaff", false)
      }
    },
    changeAdminPermit: async function() {
      console.log("this.AdminPermit", this.AdminPermit)
      if(this.AdminPermit == "true"){
        this.$store.commit('setAdmin', true )
        console.log("setAdmin", true)
      }else {
        this.$store.commit('setAdmin', false )
        console.log("setAdmin", false)
      }
    },
  }
};
</script>
